import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const recentSales = [{
  name: 'Carolina M.',
  city: 'CABA',
  time: 'hace 3 minutos'
}, {
  name: 'Florencia G.',
  city: 'Córdoba',
  time: 'hace 8 minutos'
}, {
  name: 'Agustina R.',
  city: 'Rosario',
  time: 'hace 12 minutos'
}, {
  name: 'Daniela P.',
  city: 'Mendoza',
  time: 'hace 15 minutos'
}, {
  name: 'Romina L.',
  city: 'La Plata',
  time: 'hace 22 minutos'
}, {
  name: 'Soledad V.',
  city: 'Tucumán',
  time: 'hace 27 minutos'
}, {
  name: 'Camila B.',
  city: 'Mar del Plata',
  time: 'hace 31 minutos'
}, {
  name: 'Julieta F.',
  city: 'Salta',
  time: 'hace 38 minutos'
}, {
  name: 'Milagros T.',
  city: 'Neuquén',
  time: 'hace 44 minutos'
}, {
  name: 'Lucía D.',
  city: 'San Isidro',
  time: 'hace 50 minutos'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNotification = useCallback(() => {
    if (dismissed) return;
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  }, [dismissed]);
  useEffect(() => {
    // Show first notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, [showNotification]);
  useEffect(() => {
    if (dismissed) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % recentSales.length);
      showNotification();
    }, 30000);
    return () => clearInterval(interval);
  }, [dismissed, showNotification]);
  const sale = recentSales[currentIndex];
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
  };
  return <AnimatePresence data-id="element-268">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20,
      x: 0
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 left-6 z-50 max-w-xs" data-id="element-269">
          <div className="bg-white rounded-2xl shadow-xl border border-gold/20 p-4 flex items-start gap-3 relative" data-id="element-270">
            {/* Close button */}
            <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-300 hover:text-gray-500 transition-colors" aria-label="Cerrar notificación" data-id="element-271">
              <X className="w-3.5 h-3.5" data-id="element-272" />
            </button>

            {/* Icon */}
            <div className="w-10 h-10 rounded-full bg-rose/50 flex items-center justify-center flex-shrink-0" data-id="element-273">
              <ShoppingBag className="w-5 h-5 text-coral" data-id="element-274" />
            </div>

            {/* Content */}
            <div className="pr-4" data-id="element-275">
              <p className="text-sm font-bold text-brown-deep leading-tight" data-id="element-276">
                {sale.name}{' '}
                <span className="font-normal text-brown-medium" data-id="element-277">
                  de {sale.city}
                </span>
              </p>
              <p className="text-xs text-brown-medium mt-0.5" data-id="element-278">
                Compró el Kit Vientre Plano 21D
              </p>
              <p className="text-xs text-gold font-medium mt-1" data-id="element-279">{sale.time}</p>
            </div>

            {/* Gold accent line */}
            <div className="absolute bottom-0 left-4 right-4 h-0.5 bg-gradient-to-r from-transparent via-gold/30 to-transparent rounded-full" data-id="element-280"></div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}